export const SET_DISCUSSIONS = 'SET_DISCUSSIONS';
export const SET_DISCUSSION = 'SET_DISCUSSION';
export const ADD_DISCUSSION = 'ADD_DISCUSSION';
export const UPDATE_DISCUSSION = 'UPDATE_DISCUSSION';
export const REMOVE_DISCUSSION = 'REMOVE_DISCUSSION';
export const CLEAR_DISCUSSION = 'CLEAR_DISCUSSION';
export const CLEAR_DISCUSSIONS = 'CLEAR_DISCUSSIONS';
